import {ActionTypes, CCAuthorizedAxios} from './../../cc-imports'

const LeaderBoardActions = {
    fetchLBStatuses: (authDetails, req, type)=> {
        return {
            type: ActionTypes.GET_LB_STATUS,
            payload: CCAuthorizedAxios(authDetails).get('/leaderboard/lb/'+req.lbId+'/userId/'+req.userId+'/skip/'+req.skip+'/limit/'+req.limit+'/'),
            meta: {
                type : type
            }
        }
    },

    fetchLBs: (authDetails, req, type) =>{
        return {
            type:ActionTypes.GET_LBS,
            payload:CCAuthorizedAxios(authDetails).get('/leaderboard/userId/'+req.userId+'/sponsorKey/'+req.sponsorKey+'/'),
            meta: {
                type : type
            }
        }
    }
};

export default LeaderBoardActions



// WEBPACK FOOTER //
// ./src/app/data/actions/LeaderboardActions.js